const ACCOUNT_TYPE_LIST = [
  { type: 'demo', name: 'Demo Account' },
  { type: 'customer', name: 'Customer Account' },
  { type: 'partner', name: 'Partner Account' },
  { type: 'trial', name: 'Trial Account (POC)' },
];

export default ACCOUNT_TYPE_LIST;
